export default __webpack_public_path__ + "static/media/RU.70a68efe.png";